/*
Copyright (C) 2020 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import React, { useState } from 'react';
import { ulid } from 'ulid';
import { Button } from '@broadleaf/admin-components/dist/common';

export const InvoiceAction: React.FC<FulfillmentActionProps> = ({
  color = 'primary',
  size = 'sm',
  children,
  disabled = false,
  onClick,
  tooltip = ''
}) => {
  const tooltipId = 'tooltip-' + ulid().slice(-6);
  const [isHovered, setIsHovered] = useState(false);
  return (
    <div
      className="ml-2 tw-relative"
      onMouseOver={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onFocus={() => setIsHovered(true)}
      onBlur={() => setIsHovered(false)}
    >
      <Button
        color={color}
        size={size}
        disabled={disabled}
        onClick={!disabled ? onClick : undefined}
        type="button"
        data-tooltip-target={tooltipId}
      >
        {children}
      </Button>
      {isHovered && tooltip && (
        <div
          data-tooltip={tooltipId}
          role="tooltip"
          className="tw-absolute tw-top-full tw-z-[100] tw-whitespace-normal tw-break-words tw-rounded-lg tw-bg-black tw-px-3 tw-py-1.5 tw-text-sm tw-font-normal tw-text-white focus:tw-outline-none"
        >
          <span className="rw-rounded-sm tw-absolute tw-left-1/2 tw-top-[-3px] tw--z-10 tw-h-2 tw-w-4 tw--translate-x-1/2 tw-rotate-45 tw-bg-black"></span>
          <span className="tw-text-center">{tooltip}</span>
        </div>
      )}
    </div>
  );
};

export interface FulfillmentActionProps {
  color?: string;
  size?: 'sm' | 'lg';
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  tooltip?: string;
}

export default InvoiceAction;
